import {Loader} from '@googlemaps/js-api-loader';

// Google Map
const loader = new Loader({
    apiKey: google_map_api_key,
    version: "weekly",
    libraries: ["places"],
});

async function loadGoogleMap() {
    await loader.load();
    // Initialize Google Map and find all google maps
    for (const container of document.querySelectorAll('.slider .map-canvas')) {
        let googleMapStyle = google_map_style;
        let googleMapZoom = parseInt(container.getAttribute('data-zoom'));

        let google_map_coordinates = JSON.parse(container.getAttribute('data-address'));
        if (google_map_coordinates && typeof google_map_coordinates === "object" && "lat" in google_map_coordinates && "lng" in google_map_coordinates) {
            let map;
            // Get zoom from data attribute and set to 15 if not set

            if (googleMapZoom === null) {
                googleMapZoom = 15;
            }

            let styledMap = new google.maps.StyledMapType(googleMapStyle, {
                name: "Styled Maps - Night Mode"
            });
            let myOptions = {
                zoom: googleMapZoom,
                disableDefaultUI: true,
                scrollwheel: false,
                panControl: true,
                zoomControl: false,
                zoomControlOptions: {
                    style: google.maps.ZoomControlStyle.SMALL,
                    position: google.maps.ControlPosition.BOTTOM_CENTER
                },
                scaleControl: false,
                center: google_map_coordinates,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                },
            };
            map = new google.maps.Map(container, myOptions);


            const imageUrl = templateurl + '/assets/map-marker.png';

            let image = {
                url: imageUrl,
                // This marker is 20 pixels wide by 32 pixels tall.
                scaledSize: new google.maps.Size(62, 74),
                // The origin for this image is 0,0.
                origin: new google.maps.Point(0, 0),
                // The anchor for this image is the base of the flagpole at 0,32.
                anchor: new google.maps.Point(31, 74)
            };
            new google.maps.Marker({
                map: map, position: google_map_coordinates, icon: image,
            });


            //Associate the styled map with the MapTypeId and set it to display.
            map.mapTypes.set('map_style', styledMap);
            map.setMapTypeId('map_style');


            let currCenter = map.getCenter();

            // on window resize console log
            window.addEventListener('resize', function () {
                // Recenter google map
                map.setCenter(currCenter);
            });
        }
    }
}

// Check if borlabs cookie is active
document.addEventListener("load-googlemaps", function (e) {
    loadGoogleMap();
});